export class SlackUserNotFoundError extends Error {}
